/** @format */

import React, {createRef, useEffect} from 'react';
import SuperAgent from 'superagent';

export default function GoogleLoginButton(props) {
    const ref = createRef();
    useEffect(() => {
        if (typeof google !== 'undefined') {
            google.accounts.id.initialize({
                client_id: process.env.GOOGLE_CLOUD_FRONTIER_ACCOUNT_ID,
                callback: async ({credential}) => {
                    const response = await SuperAgent.post('/account/users/google-token-verify')
                        .set('accept', 'application/json')
                        .send({token: credential})
                        .query({redirect: window.loginRedirect});

                    if (typeof window.dataLayer !== 'undefined') {
                        window.dataLayer.push({
                            event: 'login'
                        });
                    }

                    if (typeof props.onLogin === 'undefined') {
                        if (response.body.redirect) {
                            window.location.href = response.body.redirect;
                        }
                    } else {
                        props.onLogin({redirect: response.body.redirect, isLoggedIn: true});
                    }
                }
            });
            google.accounts.id.prompt();

            // https://developers.google.com/identity/gsi/web/reference/js-reference
            google.accounts.id.renderButton(ref.current, {
                theme: 'filled_blue',
                type: props.buttonType ?? 'icon',
                size: 'large'
            });
        } else {
            console.log('Google Login Disabled...');
        }
    }, []);

    return <span ref={ref}></span>;
}
